module.exports = __webpack_public_path__ + "media/images/kezdolap-20250325-1747x1536-39784ad20a77dddc38593b1ae5c496fe.jpg";